import { render, staticRenderFns } from "./Rapporten.vue?vue&type=template&id=237f313e&scoped=true"
import script from "./Rapporten.vue?vue&type=script&lang=js"
export * from "./Rapporten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237f313e",
  null
  
)

export default component.exports